import {HttpClient, HttpParams} from '@angular/common/http';
import {Injectable} from '@angular/core';
import {Observable, throwError} from 'rxjs';
import {catchError, map} from 'rxjs/operators';
import {environment} from '../../../environments/environment';
import {PromoCodeModel} from '../../models/promo-code.model';

@Injectable({
  providedIn: 'root'
})
export class PromoService {
  private apiUrl = environment.apiUrl;

  constructor(private http: HttpClient) {
  }

  getUserPromoCodes(): Observable<PromoCodeModel[]> {
    return this.http.get(`${this.apiUrl}/promo/user_promos`)
      .pipe(
        map((response: PromoCodeModel[]) => {
          return response;
        }),
        catchError(error => {
          return throwError(error);
        })
      );
  }

  getOrderPromoCodes(invoiceId: number): Observable<PromoCodeModel[]> {
    return this.http.get(`${this.apiUrl}/orders/my_promos/${invoiceId}`)
      .pipe(
        map((response: PromoCodeModel[]) => {
          return response;
        }),
        catchError(error => {
          return throwError(error);
        })
      );
  }

  addUserPromoCode(code: string): Observable<any> {
    return this.http.post(`${this.apiUrl}/promo/active_promo_user/${code}`, null)
      .pipe(
        map(response => {
          return response;
        }),
        catchError(error => {
          return throwError(error);
        })
      );
  }

  setOrderPromoCode(data: any): Observable<any> {
    return this.http.post(`${this.apiUrl}/orders/set_invoice_promo`, data)
      .pipe(
        map(response => {
          return response;
        }),
        catchError(error => {
          return throwError(error);
        })
      );
  }

  removePromo(invoiceId) {
    return this.http.post(`${this.apiUrl}/promo/remove_invoice_promo/${invoiceId}`, null)
      .pipe(
        map(response => {
          return response;
        }),
        catchError(error => {
          return throwError(error);
        })
      )
  }

  getPromoCampaignDetails(campaignId): Observable<any> {
    return this.http.get(`${this.apiUrl}/promo/campaigns/${campaignId}`)
      .pipe(
        map((response: PromoCodeModel[]) => {
          return response;
        }),
        catchError(error => {
          return throwError(error);
        })
      );
  }

  getPromoCampaignSpecialties(campaignId): Observable<any> {
    return this.http.get(`${this.apiUrl}/promo/campaigns/${campaignId}/specialties`)
      .pipe(
        map((response: PromoCodeModel[]) => {
          return response;
        }),
        catchError(error => {
          return throwError(error);
        })
      );
  }

  claimPromo(campaignId, phone): Observable<any> {
    let queryParams = new HttpParams();
    queryParams = queryParams.append('phone', phone);
    return this.http.post(`${this.apiUrl}/promo/campaigns/${campaignId}/claim`, null, {params: queryParams})
      .pipe(
        map(response => {
          return response;
        }),
        catchError(error => {
          return throwError(error);
        })
      );
  }

  sendPcrData(data) {
    return this.http.post(`${this.apiUrl}/notification/send-covid19-pcr-email`, data)
      .pipe(
        map(response => {
          return response;
        }),
        catchError(error => {
          return throwError(error);
        })
      );
  }
}
